import { useTranslation } from "react-i18next";

 function NotFoundPage() {
  const {i18n, t } = useTranslation();
  return (
    <div className="not-found-page">
        <div className="container container-full">
            <h1>{t('notFoundPage.title')}</h1>
            <button className="btn btn-white-outline-black btn-md pill pill" onClick={() => window.location.href = `/${i18n.language}`}>{t('notFoundPage.btn')}</button>
        </div>
    </div>
  );
}


export default NotFoundPage